import {
    GET_BLOG_DETAILS,
    GET_BLOG_LIST,
    GET_BUSINESS_REGISTRATION_FORM_TOKEN, GET_CART,
    GET_CATEGORY_LIST,
    GET_CONTACT_FORM_TOKEN,
    GET_CURRENCY,
    GET_CURRENT_USER,
    GET_FEATURED_PRODUCT_LIST,
    GET_LATEST_PRODUCT_LIST, GET_PARTNERS_LIST,
    GET_PRODUCT_DETAILS,
    GET_PRODUCT_LIST,
    GET_SIMILAR_PRODUCTS,
    GET_SLIDER_DATA,
    LOGIN, SAVE_CART,
    SEND_BUSINESS_REGISTRATION_FORM,
    SEND_SIMPLE_CONTACT_FORM
} from "../store/action_types";

// Returns the EUR conversion rate relative to the base currency. The display
// currency is hardcoded to EUR (never read from localStorage). Falls back to 1
// (no conversion) when the currency list hasn't loaded yet or EUR is the base
// currency itself.
function getDisplayCurrencyRate(state) {
    const selected = 'EUR';
    const entry = state.currency?.list?.find(
        c => c.name?.toLowerCase() === selected.toLowerCase()
    );
    const rate = entry?.converted_value;
    return rate && rate > 0 ? rate : 1;
}

const endpoints = {
    [LOGIN]: {
        endpoint: state => `/security/login/`,
        method: 'POST',
        payload: (state, action) => action.payload
    },
    [GET_CURRENT_USER]: {
        endpoint: state => `/user/`,
        method: 'GET',
    },
    [GET_CATEGORY_LIST]: {
        endpoint: state => `/category/`,
        method: 'GET',
    },
    [GET_PRODUCT_LIST]: {
        endpoint: state => {
            const { page, limit, selected_category, search, min_price, max_price, attribute_option_ids, sort_by, selected_brand } = state.products;
            let url = `/product/?product_name=&page=${page}&limit=${limit}&product_category=${selected_category}&product_name=${search}`;

            // Prices stored on the backend are always in the base currency.
            // The frontend displays converted values via `converted_value`
            // (display = base * converted_value), so the user types the
            // filter bounds in their displayed currency. Invert here before
            // hitting the API: base = display / converted_value.
            const rate = getDisplayCurrencyRate(state);

            const toBase = v => {
                if (v === null || v === undefined || v === '') return null;
                const n = Number(v);
                if (!Number.isFinite(n) || rate <= 0) return null;
                return n / rate;
            };

            const minBase = toBase(min_price);
            const maxBase = toBase(max_price);

            if (minBase !== null) url += `&min_price=${minBase}`;
            if (maxBase !== null) url += `&max_price=${maxBase}`;

            // Attribute filters: the user can pick one or more attribute options
            // (e.g. resolution 2K/4K). Send them as a comma-separated list under
            // `attribute_option_id`.
            if (Array.isArray(attribute_option_ids) && attribute_option_ids.length) {
                url += `&attribute_option_id=${attribute_option_ids.join(',')}`;
            }

            // Sort order (e.g. 4 = price ascending, 5 = price descending).
            if (sort_by !== null && sort_by !== undefined && sort_by !== '') {
                url += `&sort_by=${sort_by}`;
            }

            // Brand filter — the selected partner (brand) id.
            if (selected_brand !== null && selected_brand !== undefined && selected_brand !== '') {
                url += `&brand_id=${selected_brand}`;
            }
            return url;
        },
        method: 'GET',
    },
    [GET_FEATURED_PRODUCT_LIST]: {
        endpoint: state => `/product/?featured=1&&limit=100`,
        method: 'GET',
    },
    [GET_SLIDER_DATA]: {
        endpoint: state => `/slider-image/`,
        method: 'GET',
    },
    [GET_LATEST_PRODUCT_LIST]: {
        endpoint: state => `/product/?limit=12`,
        method: 'GET',
    },
    [GET_PRODUCT_DETAILS]: {
        endpoint: (state, action) => `/product/${action.payload}`,
        method: 'GET',
    },
    [GET_CURRENCY]: {
        endpoint: (state, action) => `/currency/`,
        method: 'GET',
    },
    [GET_BLOG_LIST]: {
        endpoint: (state, action) => `/post/`,
        method: 'GET',
    },
    [GET_BLOG_DETAILS]: {
        endpoint: (state, action) => `/post/${action.payload}`,
        method: 'GET',
    },
    [GET_CONTACT_FORM_TOKEN]: {
        endpoint: (state, action) => `/contact/generate-token/contact`,
        method: 'GET',
    },
    [SEND_SIMPLE_CONTACT_FORM]: {
        endpoint: (state, action) => `/contact/email`,
        method: 'POST',
        payload: (state, action) => action.payload
    },
    [GET_BUSINESS_REGISTRATION_FORM_TOKEN]: {
        endpoint: (state, action) => `/contact/generate-token/b2b_contact`,
        method: 'GET',
    },
    [SEND_BUSINESS_REGISTRATION_FORM]: {
        endpoint: (state, action) => `/contact/b2b`,
        method: 'POST',
        payload: (state, action) => action.payload
    },
    [GET_SIMILAR_PRODUCTS]: {
        endpoint: (state, action) => `/product/${action.payload}/similar`,
        method: 'GET',
    },
    [SAVE_CART]: {
        endpoint: (state, action) => `/cart/`,
        method: 'POST',
        payload: (state, action) => {
            return {cart: JSON.stringify(state.cart.items)}
        }
    },
    [GET_CART]: {
        endpoint: (state, action) => `/cart/`,
        method: 'GET',
    },
    [GET_PARTNERS_LIST]: {
        endpoint: (state, action) => `/partner/`,
        method: 'GET',
    }
};

export default endpoints;